import { render, staticRenderFns } from "./WelcomeLayout.vue?vue&type=template&id=3080d466&scoped=true&"
import script from "./WelcomeLayout.vue?vue&type=script&lang=js&"
export * from "./WelcomeLayout.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeLayout.vue?vue&type=style&index=0&id=3080d466&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3080d466",
  null
  
)

export default component.exports